<template>
  <div class="text-xl m-2 p-2">Termin cũ</div>
  <select class="mb-4 p-2" v-model="timeFilter">
    <option value="7">1 tuần trước</option>
    <option value="30">1 tháng trước</option>
    <option value="365">1 năm trước</option>
  </select>
  <table class="table mx-auto rounded">
    <tr class="bg-blue-900 text-white">
      <td>Ngày</td>
      <td>Thời gian</td>
      <td>Tên</td>
      <td>Số điện thoại</td>
      <td>Địa điểm</td>
      <td></td>
    </tr>
    <tr
      v-for="(item, index) in pastEventsRealTime"
      :key="index"
      class="bg-white shadow"
    >
      <td>{{ showDate(item.date.toDate()) }}</td>
      <td>{{ showTime(item.date.toDate(), item.duration) }}</td>
      <td>{{ item.name }}</td>
      <td>{{ item.phone }}</td>
      <td>{{ showLocation(item.location) }}</td>
      <td>
        <button class="button-red" @click="removeEvent(item.id)">Xoá</button>
      </td>
    </tr>
  </table>

  <!-- <div class="events-table">
    <div class="header"></div>
    <div v-for="(item, index) in upcomingEventsRealTime" :key="index">
      <span>{{ showDate(item.date.toDate()) }}</span>
      <span>{{ showTime(item.date.toDate()) }}</span>
      <span>{{ item.name }}</span>
      <span>{{ item.phone }}</span>
    </div>
  </div> -->
</template>

<script>
import { format, add } from "date-fns";
import useFirestoreAPI from "../hooks/firestore-api";
import { ref, watchEffect } from "vue";
// import { ref } from "vue";

export default {
  props: {
    username: String,
  },
  setup(props) {
    //   console.log("Events coming", props.events);
    const timeFilter = ref(7);

    const firestoreAPI = useFirestoreAPI();

    firestoreAPI.getPastEventsRealTime(props.username, timeFilter.value);
    const pastEventsRealTime = firestoreAPI.pastEventsRealTime;
    // });

    // const showTime = (time) => {
    //     return format
    // }
    const removeEvent = async (eventId) => {
      if (confirm("Bạn có chắc muốn xoá termin này ko?")) {
        const message = await firestoreAPI.removeEvent(eventId);
        // const message = await removeEvent(eventId);
        console.log("meesage", message);
        return message;
      } else {
        console.log("not remove");
      }
    };

    watchEffect(() =>
      firestoreAPI.getPastEventsRealTime(props.username, timeFilter.value)
    );

    // const updateTermins = () => {
    // }

    return {
      // upcomingEvents,
      pastEventsRealTime,
      removeEvent,
      timeFilter,
    };
  },
  methods: {
    showTime(time, duration) {
      return `📋 ${format(time, "HH:mm")} - ${format(
        add(time, { minutes: duration }),
        "HH:mm"
      )}`;
    },
    showDate(time) {
      return format(time, "dd.MM.yyyy");
    },
    showLocation(location) {
      let res = "";
      switch (location) {
        case "office":
          res = "Tại văn phòng";
          break;
        case "online":
          res = "Online";
          break;
        default:
          res = location;
          break;
      }
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.table > tr > td {
  @apply px-2;
}
</style>
